import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { InviteLinksGroupChannelsType } from './invite-links-group.types'
import { inviteLinksGroupService } from './invite-links-group.service'
import { LinksQueryKeyConstants } from './invite-links-group.query.constants'
import { SiteLinksGroupType } from '../site-links-group/site-links-group.types'

export function useGetGroupsByChannelIdQuery(
    channelId: number,
    options?: Omit<
        UseQueryOptions<InviteLinksGroupChannelsType[], Error>,
        'queryKey' | 'queryFn'
    > & {
        onSuccess?: (data: InviteLinksGroupChannelsType[]) => void
        onError?: () => void;
    }
) {
    return useQuery<InviteLinksGroupChannelsType[], Error>({
        queryKey: [LinksQueryKeyConstants.GroupsChannels, channelId],
        queryFn: () => inviteLinksGroupService.getGroupsForChannels(channelId),
        staleTime: 1000 * 60 * 5,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        ...options,
    })
}

export function useGetGroupsBySiteIdQuery(
    siteId: number,
    options?: UseQueryOptions<SiteLinksGroupType[], Error>
) {
    return useQuery<SiteLinksGroupType[], Error>({
        queryKey: [LinksQueryKeyConstants.GroupsSites, siteId],
        queryFn: () => inviteLinksGroupService.getGroupsForSites(siteId),
        staleTime: 1000 * 60 * 5,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        ...options,
    })
}